var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCutlery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_7981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1797 8.0526L25.1479 9.0208L24.1779 9.99076L25.1694 10.9822L24.1779 11.9736L24.9926 12.7883L24.2791 13.5018L20.8008 10.0236L16.3048 14.5196L8.58205 6.79688L7.7785 7.60043L7.83937 7.66125L7.76127 7.73936L6.81873 6.79688L6.01518 7.60043L6.06568 7.65094L5.99443 7.72219L5.06918 6.79688L4.26562 7.60043L4.996 8.3308L4.26562 9.06117L5.0073 9.80285L4.26562 10.5445L5.15373 11.4326L4.57811 12.0083L6.86168 14.2918L5.92641 15.2271V20.9627L6.75211 21.7884L5.92641 22.6141L6.15615 22.8439L5.79691 23.2031L12.3626 29.7688C13.2187 29.9206 14.0998 30 14.9995 30C23.2838 30 29.9995 23.2843 29.9995 15C29.9995 14.2353 29.9419 13.4841 29.8315 12.7502L24.1617 7.08041L24.1797 8.0526Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.06971 6.79688V10.3125H5.95137V6.79688H6.38531H6.81926V10.3125H7.70092V6.79688H8.58258V11.0541C8.58258 11.8102 7.9643 12.4232 7.20158 12.4232H6.97307V23.2031H5.7975V12.4232H5.56898C4.80627 12.4232 4.18799 11.8102 4.18799 11.0541V6.79688H5.06971Z",
    fill: "#324380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9878 11.4911V14.7532H25.1089V23.2734H23.937V6.86719C25.2431 8.05125 25.9878 9.73031 25.9878 11.4911Z",
    fill: "#202C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80225 15C8.80225 18.8832 11.9503 22.0312 15.8335 22.0312L17.4741 15L15.8335 7.96875C11.9503 7.96875 8.80225 11.1168 8.80225 15Z",
    fill: "#324380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8647 15C22.8647 11.1168 19.7167 7.96875 15.8335 7.96875V22.0312C19.7167 22.0312 22.8647 18.8832 22.8647 15Z",
    fill: "#202C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3652 14.999C10.3652 18.0193 12.8137 20.4677 15.834 20.4677L17.11 14.999L15.834 9.53027C12.8136 9.53027 10.3652 11.9787 10.3652 14.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3022 14.999C21.3022 11.9787 18.8538 9.53027 15.8335 9.53027V20.4678C18.8538 20.4677 21.3022 18.0193 21.3022 14.999Z",
    fill: "#E9EDF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_7981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutlery);
export default __webpack_public_path__ + "static/media/cutlery.3ce3517fb28e95b4c14f3b11889013ab.svg";
export { ForwardRef as ReactComponent };